<template>
    <footer class="fd-footer">
        <div class="fd-footer-content">
            <p class="fd-footer-contact">
                Contact US
            </p>
            <p class="fd-footer-contact-text">
                Institute of Microbiology, Chinese Academy of Sciences
            </p>
            <p class="fd-footer-contact-text">
                Email： <a href="mailto:CCINFO_admin@wdcm.org "> CCINFO_admin@wdcm.org </a>
                <a href="mailto:gcm_admin@wdcm.org">gcm_admin@wdcm.org</a>
            </p>
            <div id="_ideConac">
            </div>
        </div>
        <div class="fd-footer-icp">
            <div class="fd-footer-icp-content">
                <p> 京ICP备06066622号-10 | &nbsp;</p>
                |
                <img src="../../images/common/jgwbimcas.png"> &nbsp;
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502048427">
                    京公网安备11010502048427号
                </a>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
    name: "Footer",
    data() {
        return {};
    },
    methods: {
        // 引入事业单位图标
        loadScript(src, callback) {
            // 创建script标签
            var script = document.createElement("script"),
                head = document.getElementsByTagName("head")[0];
            script.type = "text/javascript";
            script.charset = "UTF-8";
            script.src = src;
            // 兼容性
            if (script.addEventListener) {
                script.addEventListener(
                    "load",
                    function () {
                        callback();
                    },
                    false
                );
            } else if (script.attachEvent) {
                script.attachEvent("onreadystatechange", function () {
                    var target = window.event.srcElement;
                    if (target.readyState == "loaded") {
                        callback();
                    }
                });
            }
            head.appendChild(script);
        },
    },
    mounted() {
        setTimeout(() => {
            this.loadScript(
                "https://dcs.conac.cn/js/33/000/0000/60426997/CA330000000604269970008.js",
                () => {}
            );
        }, 100);
    },
};
</script>
<style lang="less">
.fd-footer {
    background: #0e1c29;
    border-top: 4px solid #003996;
    height: 180px;
    position: relative;
    z-index: 100;
    .fd-footer-content {
        width: 1200px;
        margin: 0 auto;
        padding-top: 26px;
        position: relative;
        .fd-footer-contact {
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #fff;
            font-size: 16px;
            margin-bottom: 22px;
        }
        .fd-footer-contact-text {
            color: #9ea2a5;
            margin-bottom: 15px;
            a {
                color: #9ea2a5;
                text-decoration: none;
            }
        }
        #_ideConac {
            position: absolute;
            right: 6px;
            top: 25px;
            cursor: pointer;
        }
    }
    .fd-footer-icp {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        background: #000;
        height: 40px;
        .fd-footer-icp-content {
            width: 1200px;
            margin: 0 auto;
            text-align: center;
            display: flex;
            color: #767d83;
            height: 40px;
            align-items: center;
            justify-content: center;
            a {
                color: #767d83;
                text-decoration: none;
            }
        }
        // padding-left: calc((100% - 1200px) / 2);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/footers.vue